export default __webpack_public_path__ + "static/media/getStartElement1.452aafe5.svg";